import PropTypes from 'prop-types'
import styled from 'styled-components'

import Select from 'components/Select'

import RthHeaderControl from 'pages/shared/Device/RthHeaderControl'

import { color } from 'styles/colors'

const propTypes = {
  date: PropTypes.string.isRequired,
  displayResetZoom: PropTypes.bool.isRequired,
  zoomResetCallback: PropTypes.func.isRequired,
  refreshCallback: PropTypes.func.isRequired,
  dateChangedCallback: PropTypes.func.isRequired,
  datesWithData: PropTypes.arrayOf(PropTypes.string).isRequired,
  awairDeviceSelectionCallback: PropTypes.func.isRequired,
  awairDevicesData: PropTypes.arrayOf(PropTypes.shape({
    awairDeviceId: PropTypes.number,
    name: PropTypes.string
  })).isRequired
}

const HeaderControls = ({ date, displayResetZoom, zoomResetCallback, refreshCallback, dateChangedCallback, datesWithData, awairDeviceSelectionCallback, awairDevicesData }) => {
  const firstDateWithData = datesWithData[0]

  return (
    <>
      <S.TopRow>
        {(awairDevicesData.length > 1)
          ? (
            <S.Select
              selectOptions={_.map(awairDevicesData.sort((a, b) => (a.name.toLowerCase() < b.name.toLowerCase()) ? -1 : 1),
                (awairDevice) => [{ value: awairDevice.awairDeviceId.toString(), name: awairDevice.name }])}
              onChange={(event) => awairDeviceSelectionCallback(parseInt(event.target.value))}
            />)
          : null
        }
      </S.TopRow>

      <RthHeaderControl
        date={date}
        minDate={firstDateWithData}
        displayResetZoom={displayResetZoom}
        dateChangedCallback={dateChangedCallback}
        zoomResetCallback={zoomResetCallback}
        refreshCallback={refreshCallback}
        rthVariant="Awair"
        isNoData={false}
        isRTHDataLoaded
        isFullScreen={false}
        onExportCallback={() => {}}
        fullScreenIconClickedCallback={() => {}}
      />
    </>
  )
}

HeaderControls.propTypes = propTypes

export default HeaderControls

const S = {
  TopRow: styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  `,
  Select: styled(Select)`
    display: inline-block;
    text-transform: uppercase;
    font-weight: bold;
    font-family: inherit;
    font-size: 12px;
    color: ${color('rthChartDate')};
  `
}
